import { render, staticRenderFns } from "./Chain.vue?vue&type=template&id=e1d46434&scoped=true&lang=pug&"
import script from "./Chain.vue?vue&type=script&lang=js&"
export * from "./Chain.vue?vue&type=script&lang=js&"
import style0 from "./Chain.vue?vue&type=style&index=0&id=e1d46434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d46434",
  null
  
)

export default component.exports